import { CommonModule } from '@angular/common';

import { Component, Input, Output, EventEmitter, ViewChildren, QueryList, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { SplitterModule } from 'primeng/splitter';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { InMemoryStorageService } from '../../services/in-memory-storage.service';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { UserRole } from '../../auth/roles.enum';
import { RoleAccessService } from '../../auth/role-access.service';
import { MessageService } from 'primeng/api';
import { RulesService } from '../../services/rules.service';
import { ItemDetailsService } from '../../services/item-details.service';
import { LoaderService } from '../../services/loader.service';
import {
    calculateLocalStockForDisplay,
    calculateRowAmounts,
    clampDiscountPercent,
    round2,
    resolveLineNoDecPl,
    isQuantityAllowedByDecimalPlaces,
    restrictDecimalInputValue,
    qtyDisplayFormat,
} from '../item-utils';
import { refreshOrderLinesStockErrors } from '../utils/order-line-stock.util';
import { MarginValidationService } from '../../services/margin-validation.service';
import { isMarginApprovalEnabledForDivision, showLineMarginColumns, formatMarginPercent, buildLineMarginTooltip } from '../margin-approval.utils';
import { PRE_POST_TEXT_TYPES, PrePostWizardResult, PrepostTextWizardComponent } from '../../shared/prepost-text-wizard/prepost-text-wizard.component';
@Component({
    selector: 'app-item-table',
    templateUrl: './item-table.component.html',
    styleUrls: ['./item-table.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        ButtonModule,
        TableModule,
        InputIconModule,
        IconFieldModule,
        CommonModule,
        ProgressSpinnerModule,
        ToastModule,
        FluidModule,
        DividerModule,
        MessageModule,
        RouterModule,
        FormsModule,
        AutoCompleteModule,
        CommonModule,
        TableModule,
        FieldsetModule,
        PanelModule,
        SplitterModule,
        FormsModule,
        ButtonModule,
        CardModule,
        ContextMenuModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule,
        TooltipModule,
        PrepostTextWizardComponent
    ],
    providers: [ConfirmationService]
})
export class ItemTableComponent {
    @Input() itemList: any[] = [];
    @Input() readOnly: boolean = false;

    @Output() deleteItemEvent = new EventEmitter<number>();
    @Input() isManagerOrSuperUser: boolean = false;

    @Output() itemListChange = new EventEmitter<any[]>();
    @Output() tableChange = new EventEmitter<any[]>();
    @Output() summaryChange = new EventEmitter<{
        totalValue: number;
        totalDiscountValue: number;
        totalNetAmount: number;
        totalVatAmount: number;
        totalWeight: number;
        subscription: number;
    }>();
    @Output() rateBlur = new EventEmitter<any>();
    @Output() focusRateInputGridEvent = new EventEmitter<number>();
    @Output() focusDiscountInputGridEvent = new EventEmitter<number>();
    @Output() focusNextQuantityInputGridEvent = new EventEmitter<number>();
    @Output() discountBlur = new EventEmitter<any>();
    @Output() editingStateChange = new EventEmitter<boolean>();
    @Output() marginValidationFailed = new EventEmitter<{ actual: number; required: number; itemName?: string }>();
    @Input() userRoles: UserRole[] = [];
    @Input() isReadOnly!: boolean;
    @Input() deletedItems: Map<string, any[]> = new Map();
    private stockMessageDebounceMap = new Map<string, any>();
    private stockUpdateInProgress = new Map<string, boolean>();
    // ⭐ Add these new inputs
    @Input() company: string = '';
    @Input() division: string = '';
    @Input() warehouse: string = '';
    @Input() customerId: string = '';
    @Input() defaultPriceList: string = '';
    @Input() orderNumber: string = '';
    @Input() orderStatus: number | null = null;
    @Input() orderMovingStatus: string = '';
    @Input() isCreditNoteOrder: boolean = false;
    private readonly stockCheckExcludedItemNumbers = new Set([
        '27990',
        '27991',
        '27992',
        '27993',
        '27994',
        '27995'
    ]);

    isEditingRates = false;
    showLineTextWizardDialog = false;
    selectedLineTextType = '';
    selectedLineForText: any = null;
    lineTextContextMenuItems: MenuItem[] = [];
    readonly LINE_TEXT_TYPES = {
        PRE: PRE_POST_TEXT_TYPES.PRE,
        POST: PRE_POST_TEXT_TYPES.POST
        // PRE: 'LINE_PRE_TEXT',
        // POST: 'LINE_POST_TEXT'
    } as const;
    @ViewChild('lineTextMenu') lineTextMenu!: ContextMenu;
    toggleEditingRates() {
        if (this.isEditingRates) {
            for (const row of this.sortedItemList) {
                Object.assign(row, calculateRowAmounts(row));
                if (!this.applyRowMarginValidation(row, -1, null, true)) {
                    return;
                }
            }
            this.emitTableChange();
            localStorage.setItem('orderLines', JSON.stringify(this.itemList));
        }
        this.isEditingRates = !this.isEditingRates;
        this.editingStateChange.emit(this.isEditingRates);
    }
    @ViewChildren('quantityInputGrid') quantityInputs!: QueryList<ElementRef>;
    @ViewChildren('rateInputGrid') rateInputs!: QueryList<ElementRef>;
    @ViewChildren('discountInputGrid') discountInputs!: QueryList<ElementRef>;

    clear(dt: any) {
        dt.clear();
    }
    private initializeLineTextContextMenu() {
        this.lineTextContextMenuItems = [
            {
                label: 'Pre-Text Line',
                icon: 'pi pi-pencil',
                command: () => this.openLineTextWizard(this.LINE_TEXT_TYPES.PRE)
            },
            {
                label: 'Post-Text Line',
                icon: 'pi pi-pencil',
                command: () => this.openLineTextWizard(this.LINE_TEXT_TYPES.POST)
            }
        ];
    }
    onLineRightClick(event: MouseEvent, row: any) {
        if (!this.canShowLineTextActions()) {
            return;
        }
        event.preventDefault();
        this.selectedLineForText = row;
        this.lineTextMenu.show(event);
    }
    private openLineTextWizard(textType: string) {
        this.selectedLineTextType = textType;
        this.showLineTextWizardDialog = true;
    }
    onLinePrePostComplete(result: PrePostWizardResult) {
        const lineNo = this.selectedLineForText?.lineNumber?.toString()?.trim();
        const orderNumber = this.orderNumber?.trim();
        const company = this.company || this.inMemoryStorage.get('company') || '';
        const division = this.division || this.inMemoryStorage.get('division') || '';

        if (!lineNo || !company || !division) {
            this.messageService.add({
                severity: 'error',
                summary: 'Save failed',
                detail: 'Missing order/line details for line pre/post text.',
                life: 4000
            });
            return;
        }

        if (!orderNumber || orderNumber === 'New Order') {
            this.itemDetailsService.queuePendingLineText(lineNo, result.textType, result.targets);
            const typeLabel = (result.textType || '').toUpperCase().includes('PRE') ? 'Pre-Text' : 'Post-Text';
            this.messageService.add({
                severity: 'success',
                summary: 'Saved',
                detail: `${typeLabel} added to Line ${lineNo}.`,
                life: 3500
            });
            return;
        }

        this.itemDetailsService.updateOrderLineTextByDocuments(orderNumber, lineNo, company, division, result.textType, result.targets).subscribe({
            next: (message: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Saved',
                    detail: typeof message === 'string' ? message : 'Line text updated successfully.',
                    life: 3000
                });
            },
            error: (err) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Save failed',
                    detail: err?.error?.message || 'Could not save line text.',
                    life: 4000
                });
            }
        });
    }
    canShowLineTextActions(): boolean {
        if (this.readOnly || this.isReadOnly || this.isEditingRates) {
            return false;
        }
        const movingStatus = (this.orderMovingStatus || '').toUpperCase();
        if (['WIP', 'INV', 'CAN'].includes(movingStatus)) {
            return false;
        }
        return true;
    }
    get sortedItemList(): any[] {
        // Keep source order untouched; only reverse display by latest line number.
        return [...(this.itemList || [])].sort((a, b) => Number(b?.lineNumber || 0) - Number(a?.lineNumber || 0));
    }

    get showMarginColumns(): boolean {
        return showLineMarginColumns(this.division, this.isCreditNoteOrder, this.inMemoryStorage, this.warehouse);
    }

    formatMarginPercent = formatMarginPercent;

    getLineMarginTooltip(row: any): string {
        return buildLineMarginTooltip(row, this.marginValidationService);
    }

    floorValue(val: any): number {
        return Math.floor(Number(val));
    }
    ngOnInit() {
        console.log('item-table Is Read Only:', this.isReadOnly);
        console.log(this.itemList);
        this.rulesService.ruleActiveForDivision$.subscribe((flag) => {
            this.ruleActiveForDivision = flag;
            console.log('Child received ruleActiveForDivision:', flag);
        });
        this.initializeLineTextContextMenu();
    }
    // constructor(private inMemoryStorage: InMemoryStorageService) {}

    // division: string = '';
    ruleActiveForDivision: boolean = false;
    constructor(
        private rulesService: RulesService,
        private inMemoryStorage: InMemoryStorageService,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private itemDetailsService: ItemDetailsService,
        private loaderService: LoaderService,
        private marginValidationService: MarginValidationService
    ) {
        this.division = this.inMemoryStorage.get('division') || '';
    }

    onGlobalFilter(table: any, event: Event) {
        console.log('Global filter event:', event.target);

        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
        this.emitSummary();
    }

    emitTableChange() {
        this.itemListChange.emit([...this.itemList]);
        this.emitSummary();
    }
    emitSummary() {
        this.summaryChange.emit({
            totalValue: this.getTotalValue(),
            totalDiscountValue: this.getTotalDiscountValue(),
            totalNetAmount: this.getTotalNetAmount(),
            totalVatAmount: this.getTotalVatAmount(),
            totalWeight: this.getTotalWeight(),
            subscription: this.getSubscription()
        });
    }

    onQuantityBlur(row: any, rowIndex: number) {
        console.log('=== onQuantityBlur START ===');

        const allowedDecimals = resolveLineNoDecPl(row, 2);
        if (!isQuantityAllowedByDecimalPlaces(row.quantity, allowedDecimals)) {
            row.quantity = this.oldQty;
            this.messageService.add({
                severity: 'error',
                summary: 'Invalid quantity',
                detail: `Invalid quantity. Maximum ${allowedDecimals} decimal places are allowed for this item.`,
                life: 4000
            });
            return;
        }

        if (this.isCreditNoteOrder) {
            const qtyNum = Number(row.quantity);
            if (!Number.isFinite(qtyNum) || Math.abs(qtyNum) <= 0.9) {
                this.handleZeroQuantity(row, rowIndex);
                return;
            }
            row.quantity = -Math.abs(qtyNum);
            this.updateRowStatus(row);
            Object.assign(row, calculateRowAmounts(row));
            this.emitTableChange();
            localStorage.setItem('orderLines', JSON.stringify(this.itemList));
            return;
        }

        // ⭐ Normalize quantity (ensure non-negative)
        if (row.quantity < 0) {
            row.quantity = 0;
        }

        // ⭐ GUARD: Prevent duplicate calls
        const rowKey = `${row.itemNumber}_${row.lineNumber}`;
        if (this.stockUpdateInProgress.get(rowKey)) {
            console.log('⏭️ Stock update already in progress, skipping duplicate');
            // ✅ Calculate amounts even if stock update is in progress
            Object.assign(row, calculateRowAmounts(row));
            return;
        }

        // ⭐ Validate quantity first (before any API calls)
        if (row.quantity <= 0.9) {
            // Handle zero quantity
            this.handleZeroQuantity(row, rowIndex);
            return;
        }
    
        // Only proceed with stock/margin ItemDetails when quantity actually changed.
        // Status-10 exception removed: tabbing through qty without a change must not hit the API.
        const prevQty = Number(this.oldQty);
        const nextQty = Number(row.quantity);
        if (Number.isFinite(prevQty) && Number.isFinite(nextQty) && prevQty === nextQty) {
            console.log('⏭️ Quantity unchanged, skipping API call');
            Object.assign(row, calculateRowAmounts(row));
            this.emitTableChange();
            return;
        }
    
        Object.assign(row, calculateRowAmounts(row));

        this.applyRowMarginValidationWithFetch(row, rowIndex, 'quantity', () => {
            this.updateRowStatus(row);
            this.stockUpdateInProgress.set(rowKey, true);
            this.updateStockForRow(row, rowIndex);
        });
    
        console.log('=== onQuantityBlur END ===');
    }

    private handleZeroQuantity(row: any, rowIndex: number) {
        console.log('Zero quantity entered, prompting for deletion confirmation.');

        // ⭐ Store the old quantity before showing dialog
        const previousQty = this.oldQty > 0 ? this.oldQty : row.quantity || 0;

        this.confirmationService.confirm({
            header: 'Zero Quantity Entered',
            message: 'Quantity cannot be zero. Do you want to delete this article?',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Yes, Delete',
            rejectLabel: 'No, Keep',
            acceptButtonStyleClass: 'p-button-danger',
            rejectButtonStyleClass: 'p-button-secondary',
            accept: () => {
                // ⭐ Delete item - dialog will close automatically
                this.deleteItemEvent.emit(this.getActualIndex(row, rowIndex));
                console.log('✅ Item deleted');
            },
            reject: () => {
                // ⭐ Revert quantity and update
                row.quantity = previousQty;
                this.oldQty = previousQty; // Update oldQty to prevent re-triggering
                this.emitTableChange();
                console.log('✅ Quantity reverted to:', previousQty);

                // ⭐ Focus back on input after a short delay to ensure dialog is closed
                setTimeout(() => {
                    const inputElement = this.quantityInputs.toArray()[rowIndex]?.nativeElement;
                    if (inputElement) {
                        inputElement.focus();
                        inputElement.select();
                    }
                }, 100);
            },
            // ⭐ Ensure dialog closes properly
            dismissableMask: true,
            closeOnEscape: true
        });
    }
    // ⭐ Update row status and originalQuantity
    private updateRowStatus(row: any) {
        console.log('Row before status update:', JSON.parse(JSON.stringify(row)));

        // ⭐ CRITICAL: Update status and originalQuantity FIRST, before any calculations
        if (row.status === 20) {
            if (row.originalQuantity === undefined) {
                if (this.oldQty > 0) {
                    row.originalQuantity = this.oldQty;
                    row.originalStatus = 20; // ⭐ Mark that original status was 20 (saved)
                } else {
                    row.originalQuantity = row.quantity;
                    row.originalStatus = 20;
                }
            } else {
                // Preserve originalStatus if already set
                if (row.originalStatus === undefined) {
                    row.originalStatus = 20; // ⭐ Ensure originalStatus is set
                }
            }
            row.originalQuantityWasSaved = true;
            row.status = 30;
            console.log('✅ Status changed from 20 to 30');
            console.log('   originalStatus:', row.originalStatus, '(should be 20)');
        } else if (row.status === 10) {
            // ⭐ Status 10 → 30: originalQuantity was from unsaved item
            if (row.originalQuantity === undefined) {
                row.originalQuantity = this.oldQty > 0 ? this.oldQty : Number(row.quantity);
            }
            // ⭐ CRITICAL: Set originalStatus to 10 (was unsaved before editing)
            if (row.originalStatus === undefined) {
                row.originalStatus = 10; // ⭐ Mark that original status was 10 (unsaved)
            }
            row.originalQuantityWasSaved = false;
            row.status = 30;

            console.log('✅ Status changed from 10 to 30');
            console.log('   originalQuantity:', row.originalQuantity);
            console.log('   currentQty:', row.quantity);
            console.log('   originalStatus:', row.originalStatus, '(should be 10)');
            console.log('   originalQuantityWasSaved:', row.originalQuantityWasSaved);
        } else if (row.status === 30) {
            // Item is already edited, preserve originalQuantity and flag
            if (row.originalQuantity === undefined) {
                row.originalQuantity = this.oldQty > 0 ? this.oldQty : row.quantity;
                row.originalQuantityWasSaved = row.originalQuantityWasSaved !== undefined ? row.originalQuantityWasSaved : false;
                console.log('⚠️ Status 30 but no originalQuantity, setting from oldQty:', row.originalQuantity);
            }
            if (row.originalQuantityWasSaved === undefined) {
                row.originalQuantityWasSaved = false;
            }
            console.log('✅ Item already edited, originalQuantity preserved:', row.originalQuantity, 'wasSaved:', row.originalQuantityWasSaved);
        }

        // ⭐ CRITICAL: Emit changes and save to localStorage BEFORE calling updateStockForRow
        // This ensures itemList is updated with the new status
        this.emitTableChange();
        localStorage.setItem('orderLines', JSON.stringify(this.itemList));

        console.log('Row after status update:', JSON.parse(JSON.stringify(row)));
    }

    updateStockForRow(row: any, rowIndex: number) {
        console.log('=== updateStockForRow START ===');
        console.log('Row:', row);
        console.log('Company:', this.company, 'Division:', this.division);
        console.log('Warehouse:', this.warehouse, 'Customer:', this.customerId);

        if (this.isCreditNoteOrder) {
            Object.assign(row, calculateRowAmounts(row));
            const rowKey = `${row.itemNumber}_${row.lineNumber}`;
            this.stockUpdateInProgress.delete(rowKey);
            this.emitTableChange();
            return;
        }

        // Validate required inputs
        if (!this.company || !this.division || !row.itemNumber) {
            console.warn('Missing required data for stock update');
            // ⭐ Clear flag on early return
            const rowKey = `${row.itemNumber}_${row.lineNumber}`;
            this.stockUpdateInProgress.delete(rowKey);
            return;
        }

        if (this.isStockCheckExcluded(row.itemNumber)) {
            const stock = Math.max(0, Number(row.apiStock ?? row.avlStock) || 0);
            row.avlStock = stock;
            row.apiStock = stock;
            row.stockLoading = false;
            row.stockError = false;
            const rowKey = `${row.itemNumber}_${row.lineNumber}`;
            this.stockUpdateInProgress.delete(rowKey);
            this.validateQuantityAfterStockUpdate(row, rowIndex);
            this.emitTableChange();
            return;
        }

        // ⭐ Store existing stock value as fallback
        const existingStock = row.avlStock !== undefined && row.avlStock !== null ? Number(row.avlStock) : null;
        console.log('Existing stock value (fallback):', existingStock);

        // ⭐ Show loading state
        row.stockLoading = true;
        row.stockError = false;

        // Lean stock-only API (same as V2 recommendations) — not full Item Details.
        const body = {
            itno: row.itemNumber,
            whlo: this.warehouse || ''
        };

        console.log('Calling available-stock API with body:', body);

        this.loaderService.show('Loading stock...', 'Please wait...');
        this.itemDetailsService.getAvailableStock(this.company, this.division, body, 'GRID_QTY_STOCK').subscribe({
            next: (response: any) => {
                this.loaderService.hide();
                console.log('Stock API response:', response);

                const itemStockCount =
                    response?.itemStockCount ??
                    response?.ItemDetails?.itemStockCount ??
                    response?.ItemDetails?.avlStock;
                const apiStock = itemStockCount !== undefined && itemStockCount !== null && itemStockCount !== ''
                    ? Number(itemStockCount)
                    : null;

                console.log('API Stock (raw):', itemStockCount);
                console.log('API Stock (parsed):', apiStock);

                // ⭐ Only proceed if we have a valid API response
                if (apiStock === null || isNaN(apiStock)) {
                    console.warn('⚠️ Invalid API response, preserving existing stock');
                    row.stockLoading = false;
                    row.stockError = true;

                    // ⭐ Preserve existing stock if available, otherwise keep current value
                    if (existingStock !== null) {
                        row.avlStock = existingStock;
                        console.log('✅ Preserved existing stock:', existingStock);
                    } else {
                        // If no existing stock, don't set to 0 - leave it undefined
                        console.log('⚠️ No existing stock to preserve, leaving avlStock unchanged');
                    }

                    // ⭐ Clear the flag
                    const rowKey = `${row.itemNumber}_${row.lineNumber}`;
                    this.stockUpdateInProgress.delete(rowKey);

                    // ⭐ Still validate quantity with existing stock
                    console.log('Validating quantity after stock update...', row.avlStock);
                    
                    if (row.avlStock !== undefined && row.avlStock !== null) {
                        this.validateQuantityAfterStockUpdate(row, rowIndex);
                    }

                    return;
                }

                console.log('API Stock (valid):', apiStock);

                // ⭐ CRITICAL: Store raw API stock for validation use
                row.apiStock = apiStock;
                console.log('✅ Stored raw API stock:', row.apiStock);

                // ⭐ Calculate local stock (unsaved/edited items for same itemNumber)
                const localStockToSubtract = calculateLocalStockForDisplay(this.itemList, row.itemNumber, row);
                console.log('Local stock to subtract (for display):', localStockToSubtract);

                // Calculate adjusted stock
                const adjustedStock = Math.max(0, apiStock - localStockToSubtract);
                console.log('Adjusted stock:', adjustedStock);

                // ⭐ Only update if we have a valid calculated stock OR if API returned 0 (which is valid)
                // Don't overwrite existing stock with 0 if API response was invalid
                if (adjustedStock >= 0) {
                    row.avlStock = adjustedStock;
                    row.stockLoading = false;
                    row.stockError = false;
                    console.log('✅ Stock updated successfully:', row.avlStock);
                } else {
                    // This shouldn't happen due to Math.max(0, ...), but add safety check
                    console.warn('⚠️ Calculated stock is negative, preserving existing stock');
                    if (existingStock !== null) {
                        row.avlStock = existingStock;
                    }
                    row.stockLoading = false;
                    row.stockError = true;
                }

                console.log('=== updateStockForRow END ===');

                // ⭐ CRITICAL: Clear the flag on success
                const rowKey = `${row.itemNumber}_${row.lineNumber}`;
                this.stockUpdateInProgress.delete(rowKey);
  
                console.log('Validating quantity after stock update...', row.avlStock);
                
                // ⭐ CRITICAL: Validate quantity AFTER stock is updated
                this.validateQuantityAfterStockUpdate(row, rowIndex);
                this.resyncCopyOrderStockErrors();

                // Emit changes
                this.emitTableChange();
            },
            error: (error: any) => {
                this.loaderService.hide();
                console.error('Error fetching stock:', error);

                // ⭐ On error, keep existing stock (static value)
                row.stockLoading = false;
                row.stockError = true;

                // ⭐ Preserve existing stock if available
                if (existingStock !== null) {
                    row.avlStock = existingStock;
                    console.log('⚠️ API call failed, preserved existing stock:', existingStock);
                } else {
                    console.log('⚠️ API call failed, no existing stock to preserve');
                }

                console.log('=== updateStockForRow END (ERROR) ===');

                // ⭐ CRITICAL: Clear the flag on error
                const rowKey = `${row.itemNumber}_${row.lineNumber}`;
                this.stockUpdateInProgress.delete(rowKey);

                // ⭐ Still validate even if API failed (use existing stock)
                if (row.avlStock !== undefined && row.avlStock !== null) {
                    this.validateQuantityAfterStockUpdate(row, rowIndex);
                }
                this.resyncCopyOrderStockErrors();
            }
        });
    }

    private resyncCopyOrderStockErrors(): void {
        try {
            refreshOrderLinesStockErrors(this.itemList, {
                ruleActiveForDivision: this.ruleActiveForDivision,
                isCreditNoteOrder: this.isCreditNoteOrder,
                isStockCheckExcluded: (itemNumber) => this.isStockCheckExcluded(itemNumber)
            });
        } catch {
            // ignore — save gate re-evaluates
        }
    }

    // Around line 498 - validateQuantityAfterStockUpdate method
    validateQuantityAfterStockUpdate(row: any, rowIndex: number) {
        if (this.isCreditNoteOrder) {
            return;
        }
        console.log('=== validateQuantityAfterStockUpdate START ===');
        console.log('Row quantity:', row.quantity);
        console.log('Row avlStock:', row.avlStock);
        console.log('Row originalQuantity:', row.originalQuantity);
        console.log('Row status:', row.status);
        console.log('ruleActiveForDivision:', this.ruleActiveForDivision);
        console.log('row.ar:', row.ar);

        if (this.isStockCheckExcluded(row.itemNumber)) {
            row.quantityError = '';
            console.log('⏭️ Stock check excluded for item, skipping stock validation');
            console.log('=== validateQuantityAfterStockUpdate END ===');
            return;
        }

        // ⭐ Skip validation if AR restriction doesn't apply
        if (!this.ruleActiveForDivision || (row.ar != 1 && row.ar !== undefined && row.ar !== null)) {
            console.log('⏭️ AR restriction not applicable, skipping validation');
            console.log('✅ Quantity validation passed');
            console.log('=== validateQuantityAfterStockUpdate END ===');
            return;
        }

        // ⭐ For edited rows (status 30), we need to calculate available stock BEFORE the change
        // Then validate the INCREASE against that available stock
        if (row.status === 30 && row.originalQuantity !== undefined) {
            const originalQty = Number(row.originalQuantity) || 0;
            const currentQty = Number(row.quantity) || 0;
            const increase = currentQty - originalQty;

            console.log('Status 30: originalQty=', originalQty, 'currentQty=', currentQty, 'increase=', increase);

            // If quantity decreased, no validation needed (decreasing is always allowed)
            if (increase <= 0) {
                console.log('✅ Quantity decreased or unchanged, validation passed');
                console.log('=== validateQuantityAfterStockUpdate END ===');
                this.messageService.add({
                    severity: 'info',
                    summary: 'Quantity Updated',
                    detail: `Quantity decreased by ${increase} units. Quantity set to ${currentQty} units.`,
                    life: 7000,
                    key: 'custom-toast'
                });
                return;
            }

            // ⭐ CRITICAL: Use stored API stock instead of inferring it
            let apiStock: number;
            if (row.apiStock !== undefined && row.apiStock !== null) {
                // Use stored raw API stock (this is the actual backend stock)
                apiStock = row.apiStock;
                console.log('✅ Using stored raw API stock:', apiStock);

                // ⭐ NEW: Add back deleted saved items for this itemNumber
                const deletedItemsForThisItem = this.deletedItems.get(row.itemNumber) || [];
                let totalToAddBack = 0;

                deletedItemsForThisItem.forEach((deletedItem) => {
                    if (deletedItem.status === 20) {
                        // Deleted saved item: add back the quantity
                        totalToAddBack += deletedItem.quantity;
                    } else if (deletedItem.status === 30 && deletedItem.originalQuantityWasSaved === true) {
                        // Deleted edited item (from saved): add back originalQuantity
                        const originalQty = deletedItem.originalQuantity !== undefined ? deletedItem.originalQuantity : deletedItem.quantity;
                        totalToAddBack += originalQty;
                    }
                });

                // Adjust API stock to account for deleted items
                if (totalToAddBack > 0) {
                    apiStock = apiStock + totalToAddBack;
                    console.log('✅ Adjusted API stock for deleted items:', apiStock, '(added back:', totalToAddBack, ')');
                }
            } else {
                // Fallback: Infer API stock from current avlStock + local stock
                console.log('⚠️ No stored API stock, inferring from avlStock');
                const localStockWithNewQty = this.calculateLocalStock(row.itemNumber, row);
                apiStock = row.avlStock + localStockWithNewQty;
                console.log('Inferred API stock:', apiStock);
            }

            // ⭐ CRITICAL: Calculate available stock BEFORE the change (using original quantity)
            // Store the current state temporarily
            const tempCurrentQty = row.quantity;
            const tempStatus = row.status;
            const tempOriginalStatus = row.originalStatus;

            // ⭐ CRITICAL: Temporarily restore original state for "before change" calculation
            if (row.originalStatus === 10) {
                // Was unsaved before editing - temporarily restore to status 10
                row.quantity = originalQty;
                row.status = 10;
                row.originalStatus = undefined;
            } else {
                // Was saved before editing - keep status 30 but use original quantity
                row.quantity = originalQty;
            }

            // ⭐ Use calculateLocalStockForDisplay to get FULL current quantities of OTHER items
            const localStockWithOriginal = calculateLocalStockForDisplay(this.itemList, row.itemNumber, row);
            console.log('Local stock with ORIGINAL qty (using ForDisplay for accuracy):', localStockWithOriginal);

            // Restore the current state
            row.quantity = tempCurrentQty;
            row.status = tempStatus;
            row.originalStatus = tempOriginalStatus;

            // ⭐ FIX: For originalStatus=20, allow up to (apiStock + originalQty - localStockWithOriginal)
            let availableStockBeforeChange: number;
            if (row.originalStatus === 20) {
                availableStockBeforeChange = Math.max(0, apiStock + originalQty - localStockWithOriginal);
            } else {
                availableStockBeforeChange = Math.max(0, apiStock - localStockWithOriginal);
            }
            console.log('API Stock (raw backend):', apiStock);
            console.log('Local stock with ORIGINAL qty:', localStockWithOriginal);
            console.log('Available stock BEFORE change:', availableStockBeforeChange);
            console.log('Increase needed:', increase);

            // ⭐ Validate the INCREASE against available stock BEFORE change
            if (increase > availableStockBeforeChange) {
                console.log('❌ Increase exceeds available stock. Adjusting quantity.');
                console.log('Increase:', increase, 'Available Stock (before change):', availableStockBeforeChange);

                const maxQuantity = availableStockBeforeChange + originalQty;
                row.quantityError = `Max available stock is ${availableStockBeforeChange + originalQty}`;
                row.quantity = this.oldQty; // Revert to old quantity
                Object.assign(row, calculateRowAmounts(row)); // Recalculate amounts (e.g. line = qty * rate) after revert

                this.messageService.add({
                    severity: 'warn',
                    summary: 'Insufficient Stock',
                    detail: `You tried to increase quantity by ${increase} units, but only ${availableStockBeforeChange} units are available. Maximum quantity you can set: ${maxQuantity} (current: ${originalQty} + available: ${availableStockBeforeChange} = ${maxQuantity})`,
                    life: 7000,
                    key: 'custom-toast' // ⭐ Use key to target custom toast template
                });

                // ⭐ Re-emit changes after reverting quantity
                this.emitTableChange();
                localStorage.setItem('orderLines', JSON.stringify(this.itemList));

                // ⭐ DO NOT refocus - let user click manually to avoid infinite loop
                console.log('=== validateQuantityAfterStockUpdate END (REVERTED) ===');
                return;
            }

            const maxQuantity = availableStockBeforeChange + originalQty;
            console.log('maxQuantity:', maxQuantity);

            // ⭐ Use calculateLocalStockForDisplay to get actual remaining stock (subtracts FULL quantities)
            const localStockWithCurrentQty = calculateLocalStockForDisplay(this.itemList, row.itemNumber, row);
            const remainingStockAfterChange = Math.max(0, apiStock - localStockWithCurrentQty);
            console.log('remainingStockAfterChange:', remainingStockAfterChange);
            console.log('apiStock:', apiStock);
            console.log('localStockWithCurrentQty:', localStockWithCurrentQty);
            this.messageService.add({
                severity: 'info',
                summary: 'Quantity Updated',
                detail: `Quantity increased by ${increase} units.Total qty entered ${row.quantity} Maximum quantity: ${maxQuantity}`,
                life: 7000,
                key: 'custom-toast'
            });
            console.log('✅ Increase validation passed');
            console.log('=== validateQuantityAfterStockUpdate END ===');
            return;
        }

        if (row.quantity > row.avlStock) {
            console.log('❌ Quantity exceeds available stock. Adjusting quantity.');
            console.log('Quantity:', row.quantity, 'Available Stock:', row.avlStock);

            row.quantityError = `Max available stock is ${row.avlStock}`;
            row.quantity = this.oldQty; // Revert to old quantity
            Object.assign(row, calculateRowAmounts(row)); // Recalculate amounts (e.g. line = qty * rate) after revert

            this.messageService.add({
                severity: 'warn',
                summary: 'Insufficient Stock',
                detail: `You tried to set quantity to ${row.quantity} units, but only ${row.avlStock} units are available. Quantity reverted to ${this.oldQty}`,
                life: 7000,
                key: 'custom-toast' // ⭐ Use key to target custom toast template
            });

            // ⭐ Re-emit changes after reverting quantity
            this.emitTableChange();
            localStorage.setItem('orderLines', JSON.stringify(this.itemList));

            // ⭐ DO NOT refocus - let user click manually to avoid infinite loop
            console.log('=== validateQuantityAfterStockUpdate END (REVERTED) ===');
            return;
        }

        console.log('row.avlStock - row.quantity:', row.avlStock - row.quantity);

        this.messageService.add({
            severity: 'info',
            summary: 'Quantity Updated',
            detail: `Quantity set to ${row.quantity} units. Available stock remaining: ${row.avlStock - row.quantity} units`,
            life: 7000,
            key: 'custom-toast' // ⭐ Use key to target custom toast template
        });

        console.log('✅ Quantity validation passed');
        console.log('=== validateQuantityAfterStockUpdate END ===');
    }

    /**
     * Calculates local stock to subtract based on other items in itemList
     * Uses same logic as duplicate item calculation
     */
    // Around line 318 - Update calculateLocalStock to handle current row correctly

    // Around line 318 - Update calculateLocalStock to use originalStatus
    private calculateLocalStock(itemNumber: string, currentRow: any): number {
        let totalToSubtract = 0;

        const allItems = this.itemList.filter((item) => item.itemNumber === itemNumber);

        console.log('All items with same itemNumber:', JSON.parse(JSON.stringify(allItems)));
        console.log('Current row being calculated:', JSON.parse(JSON.stringify(currentRow)));

        allItems.forEach((item) => {
            const isCurrentRow = item === currentRow || (item.lineNumber === currentRow.lineNumber && item.itemNumber === currentRow.itemNumber);

            if (item.status === 10) {
                const qty = Number(item.quantity) || 0;
                totalToSubtract += qty;
                console.log(`Status 10: Adding ${qty} to subtract (total: ${totalToSubtract})${isCurrentRow ? ' [CURRENT ROW]' : ''}`);
            } else if (item.status === 30) {
                const originalQty = item.originalQuantity !== undefined ? Number(item.originalQuantity) : Number(item.quantity);
                const currentQty = Number(item.quantity) || 0;

                // ⭐ Use originalStatus instead of originalQuantityWasSaved
                const originalStatus = item.originalStatus;

                console.log(`Status 30 item: originalQty=${originalQty}, currentQty=${currentQty}, originalStatus=${originalStatus}${isCurrentRow ? ' [CURRENT ROW]' : ''}`);

                if (originalStatus === 10) {
                    // ⭐ FIX: Was unsaved before editing → subtract only DIFFERENCE
                    // The original quantity was already subtracted when it was status 10
                    // So we only need to subtract the increase (currentQty - originalQty)
                    const difference = currentQty - originalQty;
                    totalToSubtract += difference;
                    console.log(`Status 30 (originalStatus=10): difference=${difference} (originalQty=${originalQty} was already subtracted, only subtracting increase) (total: ${totalToSubtract})`);
                } else if (originalStatus === 20) {
                    // Was saved before editing → subtract only difference
                    const difference = currentQty - originalQty;
                    totalToSubtract += difference;
                    console.log(`Status 30 (originalStatus=20): difference=${difference} (total: ${totalToSubtract})`);
                } else {
                    // Fallback to originalQuantityWasSaved
                    if (item.originalQuantityWasSaved === false || item.originalQuantityWasSaved === undefined) {
                        // ⭐ FIX: If originalQuantityWasSaved is false, it means it was unsaved
                        // So subtract only the difference (original was already subtracted)
                        const difference = currentQty - originalQty;
                        totalToSubtract += difference;
                        console.log(`Status 30 (originalStatus undefined, fallback to wasSaved=false): difference=${difference} (total: ${totalToSubtract})`);
                    } else {
                        // Was saved, subtract only difference
                        const difference = currentQty - originalQty;
                        totalToSubtract += difference;
                        console.log(`Status 30 (originalStatus undefined, fallback to wasSaved=true): difference=${difference} (total: ${totalToSubtract})`);
                    }
                }
            }
        });

        console.log('Total local stock to subtract:', totalToSubtract);
        return totalToSubtract;
    }
    emitOnRateBlur(row: any) {
        this.rateBlur.emit(row);
    }
    oldQty: number = 0;
    oldRate: number = 0;
    oldDiscount: number = 0;

    previousRate(row: any) {
        this.oldRate = Number(row.rate) || 0;
    }

    previousDiscount(row: any) {
        this.oldDiscount = Number(row.discount) || 0;
    }

    private applyRowMarginValidation(
        row: any,
        rowIndex: number,
        revertField: 'quantity' | 'rate' | 'discount' | null,
        emitFailure = true
    ): boolean {
        if (this.isCreditNoteOrder) {
            return true;
        }

        const result = this.marginValidationService.validateRowContributionMargin(row);
        if (!result) {
            return true;
        }
        if (result.isValid) {
            row.marginBelowMinimum = false;
            row.lineCost = this.marginValidationService.resolveLineCost(row);
            row.calculatedMargin = result.actualMarginPercent;
            row.minimumMargin = result.minimumMarginPercent;
            return true;
        }
        if (isMarginApprovalEnabledForDivision(this.division)) {
            row.marginBelowMinimum = true;
            row.calculatedMargin = result.actualMarginPercent;
            row.minimumMargin = result.minimumMarginPercent;
            if (emitFailure) {
                this.marginValidationFailed.emit({
                    actual: result.actualMarginPercent,
                    required: result.minimumMarginPercent,
                    itemName: row.itemName
                });
            }
            return true;
        }
        row.marginBelowMinimum = false;
        row.calculatedMargin = result.actualMarginPercent;
        row.minimumMargin = result.minimumMarginPercent;
        return true;
    }

    private applyRowMarginValidationWithFetch(
        row: any,
        rowIndex: number,
        field: 'quantity' | 'rate' | 'discount' | null,
        onPassed?: () => void
    ): void {
        // Cost/MCM are unit-level and loaded at copy/excel/add — qty change does not re-fetch ItemDetails.
        if (!this.applyRowMarginValidation(row, rowIndex, field, true)) {
            return;
        }
        onPassed?.();
    }

    private revertRowField(row: any, field: 'quantity' | 'rate' | 'discount', rowIndex: number) {
        if (field === 'quantity' && this.oldQty > 0) {
            row.quantity = this.oldQty;
        } else if (field === 'rate' && this.oldRate > 0) {
            row.rate = this.oldRate;
        } else if (field === 'discount') {
            row.discount = this.oldDiscount;
        }
        Object.assign(row, calculateRowAmounts(row));
        this.emitTableChange();
        localStorage.setItem('orderLines', JSON.stringify(this.itemList));
        setTimeout(() => {
            const inputs =
                field === 'quantity'
                    ? this.quantityInputs
                    : field === 'rate'
                      ? this.rateInputs
                      : this.discountInputs;
            inputs.toArray()[rowIndex]?.nativeElement?.focus();
        }, 100);
    }

    previousQty(row: any, rowIndex: number) {
        console.log('=== previousQty (on focus) START ===');
        console.log('Row:', JSON.parse(JSON.stringify(row)));
        console.log('Row status:', row.status);
        console.log('Row quantity:', row.quantity);

        // ⭐ ALWAYS set oldQty, regardless of ruleActiveForDivision
        // This ensures we have the original quantity for validation
        this.oldQty = row.quantity;
        console.log('✅ Previous quantity stored (oldQty):', this.oldQty);

        if (this.ruleActiveForDivision) {
            // ⭐ CRITICAL: If this is a saved item (status 20), capture originalQuantity NOW
            // This ensures we capture the ORIGINAL saved quantity, not the edited one
            if (row.status === 20 && row.originalQuantity === undefined) {
                row.originalQuantity = row.quantity;
                console.log('✅ Captured originalQuantity for status 20 item:', row.originalQuantity);
            } else if (row.status === 30 && row.originalQuantity === undefined) {
                // If somehow status is 30 but originalQuantity is missing, use current quantity
                row.originalQuantity = row.quantity;
                console.log('⚠️ Status 30 but no originalQuantity, setting to current:', row.originalQuantity);
            } else if (row.originalQuantity !== undefined) {
                console.log('✅ originalQuantity already exists:', row.originalQuantity);
            }
        }

        console.log('=== previousQty END ===');
    }

    validateQuantity(row: any, rowIndex: number) {
        console.log('=== validateQuantity START ===');
        console.log('Row quantity:', row.quantity);
        console.log('Row avlStock:', row.avlStock);
        console.log('Stock loading:', row.stockLoading);

        if (this.isStockCheckExcluded(row.itemNumber)) {
            row.quantityError = '';
            console.log('⏭️ Stock check excluded for item, skipping stock validation');
            console.log('=== validateQuantity END ===');
            return;
        }

        // ⭐ Business rule: quantity must be greater than 0.01 to be considered valid
        const minBusinessQty = 0.01;
        if (row.quantity == null || row.quantity <= minBusinessQty) {
            row.quantityError = `Quantity must be greater than ${minBusinessQty}`;
            console.log('❌ Quantity below minimum business threshold');
            console.log('=== validateQuantity END ===');
            return;
        }

        // 🚫 Case 2: Exceeds available stock (validate with current stock)
        if (row.quantity > row.avlStock && this.ruleActiveForDivision && row.ar == 1) {
            console.log('❌ Quantity exceeds available stock. Adjusting quantity.');
            console.log('Quantity:', row.quantity, 'Available Stock:', row.avlStock);
            row.quantityError = `Max available stock is ${row.avlStock}`;
            row.quantity = this.oldQty; // Revert
            this.messageService.add({ severity: 'info', summary: 'Quantity Reverted', detail: `Reverted to previous quantity of ${this.oldQty}.`, life: 5000 });
            setTimeout(() => {
                this.quantityInputs.toArray()[rowIndex]?.nativeElement.focus();
            });
            return;
        }

        // ⭐ Skip stock-related validation if stock is currently being loaded (will validate after update)
        if (row.stockLoading) {
            console.log('⏭️ Stock is loading, stock validation will happen after stock update');
            console.log('✅ Quantity validation passed (stock check deferred)');
            console.log('=== validateQuantity END ===');
            return;
        }

        // ⭐ If avlStock is not set, skip stock validation (will be set by updateStockForRow)
        if (!row.avlStock && row.avlStock !== 0) {
            console.log('⏭️ avlStock not set yet, skipping stock validation');
            console.log('✅ Quantity validation passed (stock check deferred)');
            console.log('=== validateQuantity END ===');
            return;
        }

        console.log('✅ Quantity validation passed');
        console.log('=== validateQuantity END ===');
    }
    shouldHideStockInfo(row: any): boolean {
        return this.isStockCheckExcluded(row?.itemNumber);
    }
    private isStockCheckExcluded(itemNumber: unknown): boolean {
        return this.stockCheckExcludedItemNumbers.has(String(itemNumber ?? '').trim());
    }

    validateRate(row: any, rowIndex: number) {
        console.log('Validating rate for row:', row);
        console.log('Minimum rate for row:', row.minrate);
        const minBusinessRate = 0.01;

        // ⭐ Business rule: rate must be greater than 0.01
        if (row.rate == null || row.rate <= minBusinessRate) {
            row.rateError = `Rate must be greater than ${minBusinessRate.toFixed(2)}`;
            console.log('❌ Rate below minimum business threshold');
            setTimeout(() => {
                this.rateInputs.toArray()[rowIndex]?.nativeElement.focus();
            });
            return;
        }

        if (!this.isManagerOrSuperUser) {
            // Non-managers: enforce minrate
            if (row.rate < row.minrate) {
                row.rateError = `Rate must be at least ${Number(row.minrate).toFixed(2)}`;
                row.rate = row.minrate;
                setTimeout(() => {
                    this.rateInputs.toArray()[rowIndex]?.nativeElement.focus();
                });
                return;
            }
        }
        row.rateError = '';
        Object.assign(row, calculateRowAmounts(row));
        this.applyRowMarginValidationWithFetch(row, rowIndex, 'rate', () => {
            this.emitOnRateBlur(row);
        });
    }
    emitFocusRateInputGrid(rowIndex: number) {
        console.log('Emitting focus for rate input grid at row index:', rowIndex);

        this.focusRateInputGridEvent.emit(rowIndex);
    }
    emitFocusDiscountInputGrid(rowIndex: number) {
        console.log('Emitting focus for discount input grid at row index:', rowIndex);

        this.focusDiscountInputGridEvent.emit(rowIndex);
    }
    emitFocusNextQuantityInputGrid(rowIndex: number) {
        console.log('Emitting focus for next quantity input grid at row index:', rowIndex);
        this.focusNextQuantityInputGridEvent.emit(rowIndex);
    }
    onDiscountChange(row: any, value: any) {
        const num = Number(value);
        if (Number.isFinite(num) && num > 100) {
            this.messageService.add({ severity: 'warn', summary: 'Discount', detail: 'Discount cannot exceed 100.', life: 3000 });
        }
        row.discount = clampDiscountPercent(value);
        this.emitTableChange();
    }
    emitOnDiscountBlur(row: any, rowIndex: number) {
        Object.assign(row, calculateRowAmounts(row));
        this.applyRowMarginValidationWithFetch(row, rowIndex, 'discount', () => {
            this.discountBlur.emit(row);
            this.emitTableChange();
        });
    }

    getTotalValue(): number {
        const sum = this.itemList.reduce((s, item) => s + (item.amount || 0), 0);
        return round2(sum);
    }
    getTotalDiscountValue(): number {
        const sum = this.itemList.reduce((s, item) => s + ((item.amount || 0) - (item.amountAfterDiscount || 0)), 0);
        return round2(sum);
    }
    getTotalNetAmount(): number {
        const sum = this.itemList.reduce((s, item) => s + (item.amountAfterDiscount || 0), 0);
        return round2(sum);
    }
    getTotalWeight(): number {
        const sum = this.itemList.reduce((s, item) => {
            const netWeight = Number(item.netWeight) || 0;
            const quantity = Number(item.quantity) || 0;
            return s + (netWeight * quantity);
        }, 0);
        return round2(sum);
    }
    /** VAT at header level: group lines by VAT rate, apply round2 once per rate bucket, then sum. Supports mixed rates (e.g. 21%, 9%, 0%). */
    getTotalVatAmount(): number {
        const netByRate = new Map<number, number>();
        for (const item of this.itemList || []) {
            const rate = Number(item.vat) ?? 0;
            const net = Number(item.amountAfterDiscount) ?? 0;
            netByRate.set(rate, (netByRate.get(rate) ?? 0) + net);
        }
        let vatTotal = 0;
        netByRate.forEach((netSum, rate) => {
            vatTotal += round2((netSum * rate) / 100);
        });
        return round2(vatTotal);
    }
    getSubscription(): number {
        return round2(this.getTotalNetAmount() + this.getTotalVatAmount());
    }

    focusRateInputGrid(rowIndex: number) {
        const arr = this.rateInputs.toArray();
        if (arr[rowIndex]) arr[rowIndex].nativeElement.focus();
    }
    focusDiscountInputGrid(rowIndex: number) {
        const arr = this.discountInputs.toArray();
        if (arr[rowIndex]) arr[rowIndex].nativeElement.focus();
    }
    focusNextQuantityInputGrid(rowIndex: number) {
        const arr = this.quantityInputs.toArray();
        if (arr[rowIndex + 1]) arr[rowIndex + 1].nativeElement.focus();
    }
    focusNextQuantityInputGridDown(rowIndex: number) {
        const arr = this.quantityInputs.toArray();
        if (arr[rowIndex + 1]) {
            arr[rowIndex + 1].nativeElement.focus();
        }
    }
    focusPrevQuantityInputGridUp(rowIndex: number) {
        const arr = this.quantityInputs.toArray();
        if (arr[rowIndex - 1]) {
            arr[rowIndex - 1].nativeElement.focus();
        }
    }
    selectAll(event: any) {
        event.target.select();
    }
    focusNextRateInputGridDown(rowIndex: number) {
        const arr = this.rateInputs.toArray();
        if (arr[rowIndex + 1]) {
            arr[rowIndex + 1].nativeElement.focus();
        }
    }
    focusPrevRateInputGridUp(rowIndex: number) {
        const arr = this.rateInputs.toArray();
        if (arr[rowIndex - 1]) {
            arr[rowIndex - 1].nativeElement.focus();
        }
    }
    focusNextDiscountInputGridDown(rowIndex: number) {
        const arr = this.discountInputs.toArray();
        if (arr[rowIndex + 1]) {
            arr[rowIndex + 1].nativeElement.focus();
        }
    }
    focusPrevDiscountInputGridUp(rowIndex: number) {
        const arr = this.discountInputs.toArray();
        if (arr[rowIndex - 1]) {
            arr[rowIndex - 1].nativeElement.focus();
        }
    }

    deleteItem(index: number) {
        const actualIndex = this.getActualIndex(this.sortedItemList[index], index);
        this.confirmationService.confirm({
            header: 'Delete Confirmation',
            message: 'Are you sure you want to delete this item?',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptButtonStyleClass: 'p-button-danger',
            rejectButtonStyleClass: 'p-button-secondary',
            accept: () => {
                this.deleteItemEvent.emit(actualIndex);
            }
        });
    }
    private getActualIndex(row: any, fallbackIndex: number): number {
        const index = this.itemList.indexOf(row);
        return index >= 0 ? index : fallbackIndex;
    }
    onRateEnterTable(rowIndex: number) {
        if (this.division === '400') {
            console.log('Focusing next quantity input for row:', rowIndex);
            this.focusNextQuantityInputGrid(rowIndex);
        } else {
            console.log('Focusing discount input for row:', rowIndex);

            this.focusDiscountInputGrid(rowIndex);
        }
    }
    restrictRowDecimals(event: any, row: any, field: 'quantity' | 'rate' | 'discount'): void {
        let value = event.target.value;
        const maxDecimals = field === 'quantity'
            ? resolveLineNoDecPl(row, 2)
            : 2;
        const restricted = restrictDecimalInputValue(String(value ?? ''), maxDecimals);
        if (restricted !== value) {
            event.target.value = restricted;
            value = restricted;
        }
        row[field] = Number(value);
    }
    roundForDisplay(value: number): number {
        return round2(Number(value) ?? 0);
    }

    getQtyDisplayFormat(row: any): string {
        return qtyDisplayFormat(resolveLineNoDecPl(row, 2), row?.quantity, 2);
    }
}
